/**
 * 验证码生成mixin
 */
export default {
  data() {
    return {
      captchaCode: '' // 存储生成的验证码
    }
  },
  methods: {
    /**
     * 生成随机验证码
     * @returns {string} 生成的验证码
     */
    generateCaptcha() {
      const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
      let code = '';
      for (let i = 0; i < 4; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.captchaCode = code;
      return code;
    },

    /**
     * 生成验证码图片
     */
    generateCaptchaImage() {
      const canvas = this.$refs.captchaCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const width = canvas.width = 120;
      const height = canvas.height = 40;

      // 清空画布
      ctx.clearRect(0, 0, width, height);

      // 生成随机背景色
      ctx.fillStyle = '#f5f5f5';
      ctx.fillRect(0, 0, width, height);

      // 生成验证码
      const code = this.generateCaptcha();

      // 绘制验证码
      const fontSize = 30;
      ctx.font = fontSize + 'px Arial';
      ctx.textAlign = 'center';

      // 随机颜色
      const colors = ['#333', '#666', '#999', '#336699', '#6699cc'];

      // 绘制每个字符
      for (let i = 0; i < code.length; i++) {
        ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];
        // 随机旋转角度
        const rotation = (Math.random() - 0.5) * 0.5;
        ctx.save();
        ctx.translate(20 + i * 25, height / 2);
        ctx.rotate(rotation);
        ctx.fillText(code[i], 0, fontSize / 4);
        ctx.restore();
      }

      // 绘制干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = colors[Math.floor(Math.random() * colors.length)];
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(Math.random() * width, Math.random() * height);
        ctx.lineTo(Math.random() * width, Math.random() * height);
        ctx.stroke();
      }

      // 绘制干扰点
      for (let i = 0; i < 20; i++) {
        ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];
        ctx.beginPath();
        ctx.arc(Math.random() * width, Math.random() * height, 1, 0, Math.PI * 2);
        ctx.fill();
      }
    },

    /**
     * 刷新验证码
     */
    refreshCaptcha() {
      this.generateCaptchaImage();
    }
  }
}